import React from 'react';
import BaseChart from './BaseChart';
import { EChartsOption } from 'echarts';

interface HorizontalBarChartProps {
  data: {
    name: string;
    value: number;
    color?: string;
  }[];
  title?: string;
  className?: string;
  loading?: boolean;
  showPercentage?: boolean;
}

const HorizontalBarChart: React.FC<HorizontalBarChartProps> = ({
  data,
  title,
  className,
  loading = false,
  showPercentage = false
}) => {
  const option: EChartsOption = {
    title: {
      text: title,
      textStyle: {
        color: '#1f2937',
        fontSize: 16
      },
      top: 10,
      left: 10
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      },
      formatter: function(params: any) {
        const param = params[0];
        return `${param.name}: ${param.value}${showPercentage ? '%' : ''}`;
      },
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      textStyle: {
        color: '#1f2937'
      }
    },
    grid: {
      left: '15%',
      right: '10%',
      top: '15%',
      bottom: '10%',
      containLabel: true
    },
    xAxis: {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: '#d1d5db'
        }
      },
      axisLabel: {
        color: '#6b7280',
        formatter: function(value: number) {
          return showPercentage ? `${value}%` : value.toString();
        }
      },
      splitLine: {
        lineStyle: {
          color: '#d1d5db'
        }
      }
    },
    yAxis: {
      type: 'category',
      data: data.map(item => item.name),
      axisLine: {
        lineStyle: {
          color: '#d1d5db'
        }
      },
      axisLabel: {
        color: '#6b7280'
      },
      axisTick: {
        show: false
      }
    },
    series: [
      {
        type: 'bar',
        data: data.map((item, index) => ({
          name: item.name,
          value: item.value,
          itemStyle: {
            color: item.color || ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6'][index % 5],
            borderRadius: [0, 4, 4, 0]
          }
        })),
        barWidth: '60%',
        label: {
          show: true,
          position: 'right',
          formatter: function(params: any) {
            return `${params.value}${showPercentage ? '%' : ''}`;
          },
          color: '#1f2937',
          fontSize: 11
        }
      }
    ]
  };

  return (
    <BaseChart
      option={option}
      className={className}
      loading={loading}
    />
  );
};

export default HorizontalBarChart;